module.exports = __webpack_public_path__ + "img/jqsj32.fe2d7715.svg";